import { Size } from "@repo/ui/helpers/helpers";
import {
  SegmentedControl,
  type SegmentedControlOption,
} from "@repo/ui/toggleButton/segmentedControl";
import { IconUser, IconUsersGroup } from "@tabler/icons-react";
import type { FC } from "react";
import z from "zod";

export interface TeamDisplayToggleProps {
  value: TeamDisplayMode;
  onChange: (value: TeamDisplayMode) => void;
}

export type TeamDisplayMode = z.infer<typeof teamDisplayModeSchema>;

const teamDisplayModes = ["teammates", "groups"] as const;
const teamDisplayModeSchema = z.enum(teamDisplayModes);

const teamDisplayOptions: readonly SegmentedControlOption<TeamDisplayMode>[] = [
  {
    id: "teammates",
    label: "Teammates",
    icon: <IconUser className="size-4 shrink-0" />,
  },
  {
    id: "groups",
    label: "Groups",
    icon: <IconUsersGroup className="size-4 shrink-0" />,
  },
];

export const TeamDisplayToggle: FC<TeamDisplayToggleProps> = (props) => {
  const { value, onChange } = props;
  return (
    <SegmentedControl
      aria-label="Group by"
      size={Size.SMALL}
      isIconOnly
      options={teamDisplayOptions}
      value={value}
      onChange={onChange}
    />
  );
};
